export default __webpack_public_path__ + "legacy/static/media/close-icon.ef88e38d.svg";